/*
 *  Add target="_blank" attr to inserted links on richtext elements
 *
 *
 *  Version:
 *    1.0.0 - 2020/08/07
 */

import $ from 'jquery';

const RICHTEXT_SELECTOR = '[data-richtext]';

export const Richtext = () => {
  let links = $(RICHTEXT_SELECTOR).find('a');
  let validLinks = links.filter(link => $(link).attr('href') != '#');
  validLinks.attr('target', '_blank');
}

$(document).ready(() => Richtext());